const MAX_INTERNAL_ROUTE_LENGTH = 2048;
const ALLOWED_NOTIFICATION_ROUTE_PREFIXES = Object.freeze([
  "/souvenirs/capsules",
  "/notifications",
  "/mes-eternua",
  "/forum",
  "/chat",
  "/market",
  "/voyage",
  "/amis",
  "/cercles-du-jour",
  "/groupes",
  "/cercles",
  "/evenements",
  "/projets",
  "/communaute",
  "/confiance-confidentialite",
  "/wallet",
]);

function decodedRoute(value) {
  let decoded = value;
  for (let pass = 0; pass < 2; pass += 1) {
    try {
      const next = decodeURIComponent(decoded);
      if (next === decoded) break;
      decoded = next;
    } catch (_error) {
      return "";
    }
  }
  return decoded;
}

function hasControlCharacters(value) {
  return Array.from(String(value || "")).some((character) => {
    const code = character.charCodeAt(0);
    return code <= 31 || code === 127;
  });
}

function containsUnsafePathSyntax(value) {
  const decoded = decodedRoute(value);
  if (!decoded) return true;
  if (
    hasControlCharacters(decoded)
    || decoded.includes("\\")
    || decoded.includes("//")
  ) return true;
  const rawPath = String(value).split(/[?#]/)[0];
  const decodedPath = decoded.split(/[?#]/)[0];
  return [rawPath, decodedPath].some((path) => {
    if (
      hasControlCharacters(path)
      || path.includes("\\")
      || path.includes("//")
    ) {
      return true;
    }
    return path.split("/").some((segment) => segment === "." || segment === "..");
  });
}

function isAllowlistedPath(pathname) {
  return ALLOWED_NOTIFICATION_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

function validateInternalRoute(value) {
  if (typeof value !== "string") return "";
  const route = value.trim();
  if (
    !route ||
    route.length > MAX_INTERNAL_ROUTE_LENGTH ||
    !route.startsWith("/") ||
    route.startsWith("//") ||
    hasControlCharacters(route) ||
    containsUnsafePathSyntax(route)
  ) {
    return "";
  }

  try {
    const origin =
      typeof window !== "undefined" && window.location?.origin
        ? window.location.origin
        : "https://eternua.invalid";
    const parsed = new URL(route, origin);
    if (
      parsed.origin !== origin
      || !parsed.pathname.startsWith("/")
      || !isAllowlistedPath(parsed.pathname)
    ) return "";
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch (_error) {
    return "";
  }
}

export function isSafeNotificationRoute(value) {
  return Boolean(validateInternalRoute(value));
}

export function getSafeNotificationRoute(value, fallback = "") {
  return validateInternalRoute(value) || validateInternalRoute(fallback);
}
